<template>
  <div class="wrapper login" @click="divClick">
    <div class="body"></div>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      子画面定義：利用規約画面(STDSCM04C05)  ログイン時、利用規約未同意で表示                                       _/
           _/                                                                                                                    _/
      _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <TearmsOfService
      :requiredTermsOfUseUrl="requiredTermsOfUseUrl"
      @confirm="confirm"
      @close="close"
    ></TearmsOfService>
  </div>
</template>

<script>
import _ from "lodash";
import Common from "@/util/common.js";
import {
  API_OidcAlignment
} from "@/api/Modules/CM01/STDSCM01C05.js";
// import ErrorMessage from "@/components/ErrorMessage.vue";
// import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import TearmsOfService from "@/components/STDSCM01C05TearmsOfServiceModal.vue";
import { API_Login } from "@/api/Modules/CM01/STDSCM01C02.js";
import { mapMutations, mapGetters } from "vuex";
export default {
  name: "STDSCM01C02Login",
  components: {
    TearmsOfService,
    // ErrorMessage,
    // ErrorMessageCase,
  },
  computed: {
    ...mapGetters("businessModule", ["isTermsServiceShow"]),
  },
  data() {
    return {
      message: "",
      errors: [], // エラー情報
      RGMessage: Common.getMessage("MTCL2002", []), //事業者用メッセージ
      msg: Common.getMessage("MTCL2070", []), //capslockメッセージ
      requiredTermsOfUseUrl: "",
      requiredTermsOfUseVersion: null,
      requiredTermsOfUseId: null,
      LoginParam: {
        tatsuzinId: null,
          loginInfoSaveFlag: true,
          agreedTermsOfUseVersion:null,
          agreedTermsOfUseId: null,
          password:null,
      },
    };
  },
  created() {
    this.processDialogue(false);
    let code = this.$route.query.code;
    let kinyuCode = this.$route.query.kinyuCode;
    if (code && kinyuCode) {
      this.processDialogue(true);
      let param = {
        code: code,
        kinyuCode: kinyuCode,
      };
      API_OidcAlignment(param).then((response) => {
        this.processDialogue(false);
        this.LoginParam = {
          tatsuzinId: response.tatsuzinId,
          loginInfoSaveFlag: true,
          agreedTermsOfUseVersion: response.requiredTermsOfUseVersion,
          agreedTermsOfUseId: response.requiredTermsOfUseId,
          password: response.password,
        };
        if (response.result == "0000") {
          this.$cookies.set("isBopLogin", "true", "0");
          this.$cookies.set("SessionID", response.sessionID, "0");
          this.$cookies.set("bopPreOcclusionFlag", true, "0");
          this.$cookies.set("isloginHendle", true, "0");
          this.updateBusinessOperatorFlag(true);
          if (response.availableDays !== 0) {
            this.message = Common.getMessage("MTCL2071", [
              response.availableDays,
            ]);
          } else {
            this.goToFilelist()
          }
        } else if (response.result == "0900" || response.result == "0901") {
          this.requiredTermsOfUseVersion = response.requiredTermsOfUseVersion;
          this.requiredTermsOfUseId = response.requiredTermsOfUseId;
          this.requiredTermsOfUseUrl = response.requiredTermsOfUseUrl;
          //利用規約未同意画面表示
          this.termsServiceDialogue(true);
        } else if (response.result == "1700") {
          //事業者の場合で初回ログインの場合
          this.isProcessShow = true;
        } else if (response.result == "0800") {
          //体験版利用期限切れ 指定ページに遷移する。
          window.location.href = response.url;
        } else {
          // エラー時フォーカス制御
          this.passwordtemp = "";
          switch (response.result) {
            case "0701":
              this.$refs.id.focus();
              break;
            default:
              this.$refs.password.focus();
              break;
          }
          // 入力クリア
          this.LoginParam.password = "";
          this.LoginParam.loginInfoSaveFlag = false;
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
        if(response.toRedirectUrl){
          sessionStorage.setItem(
            "toRedirectUrl",
            response.toRedirectUrl
          );
        }
      });
    }
  },
  methods: {
    ...mapMutations("businessModule", [
      "termsServiceDialogue",
      "processDialogue",
    ]),
    ...mapMutations("businessOperatorModule", ["updateBusinessOperatorFlag"]),
    // ログイン処理：利用規約同意
    confirm() {
      this.processDialogue(true);     
      API_Login(this.LoginParam)
        .then((response) => {
          if (response.result == "0000") {
            this.$cookies.set("isBopLogin", "true", "0");
            this.$cookies.set("SessionID", response.sessionID, "0");
            this.$cookies.set("bopPreOcclusionFlag", true, "0");
            this.$cookies.set("isloginHendle", true, "0");
            //利用規約未同意画面非表示
            this.termsServiceDialogue(false);
            this.goToFilelist()
          }
        })
        .finally(() => {
          this.processDialogue(false);
        });
    },
    close() {
      this.termsServiceDialogue(false);
      this.$router.go(-1);
    },
    goToFilelist(){
      sessionStorage.setItem(
        "isOidc",
        1
      );
      this.$router.push({
        name: "STFMFM02C29",
      });
    }
  },
};
</script>